<template>
	<TutorialInterfaceItem :isShowing="isShowing" class="tutorial-time-bar">
		<TimeBar slot="component" />
	</TutorialInterfaceItem>
</template>

<script>
import TimeBar from '@/components/board/TimeBar';
import TutorialInterfaceItem from '@/components/tutorial/TutorialInterfaceItem';
import tooltips from '@/mixins/tooltips';

export default {
	name: 'TutorialTimeBar',
	mixins: [tooltips],
	components: {
		TimeBar,
		TutorialInterfaceItem,
	},
	computed: {
		isShowing() {
			return this.tooltipLocation === "timeBar" && this.tooltipShowing;
		},
	},
	watch: {
		tooltipLocation(newLocation, oldLocation) {
			if (newLocation !== oldLocation) {
				this.showTooltip();
			}
		},
	},

};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/tutorial/TutorialTimeBar.vue